import React from "react";
import { motion } from "framer-motion";
import GiveawayHeader from "./GiveawayHeader";
import GiveawayFooter from "./GiveawayFooter";

export default function NoCampaign() {
  return (
    <div className="min-h-screen overflow-x-hidden w-full" style={{ background: "#000" }}>
      <GiveawayHeader />
      <section dir="rtl" className="flex flex-col items-center justify-center text-center px-6" style={{ minHeight: "70vh" }}>
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          className="max-w-lg"
        >
          <p className="text-6xl mb-6">🏆</p>
          <h1 className="text-4xl font-bold text-white mb-4">הקמפיין הבא בדרך!</h1>
          <p className="text-lg mb-8" style={{ color: "#c4c4c4" }}>
            אנחנו עובדים על משהו מיוחד. הישארו מחוברים דרך הרשתות שלנו ותהיו הראשונים לדעת.
          </p>
          <div className="flex items-center justify-center gap-6">
            <a href="https://t.me/mom3ntum" target="_blank" rel="noopener noreferrer" className="text-sm font-bold px-5 py-3 rounded-full transition-all" style={{ background: "#c8f135", color: "#000" }}>
              הצטרפו לטלגרם
            </a>
            <a href="https://www.instagram.com/mom3ntum.fans" target="_blank" rel="noopener noreferrer" className="text-sm font-bold px-5 py-3 rounded-full transition-all" style={{ background: "#333", color: "#fff" }}>
              עקבו באינסטגרם
            </a>
          </div>
        </motion.div>
      </section>
      <GiveawayFooter />
    </div>
  );
}
